import { render, staticRenderFns } from "./MCQInterviewHome.vue?vue&type=template&id=2b788188&scoped=true"
import script from "./MCQInterviewHome.vue?vue&type=script&lang=js"
export * from "./MCQInterviewHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b788188",
  null
  
)

export default component.exports